import React, { useEffect, useState } from 'react';
// @ts-ignore
import { USBButton } from '@usb-shield/components-react';
import Select from '../../components/atoms/Select/Select';
import { getDefaultFilters } from './utils';
import USBDatePicker from '@usb-shield/react-date-picker';
const defaultDatePickerErrorMessages = {
  default: 'Enter a valid date.',
  118: 'Enter a valid date.',
  121: "You've reached the character limit. Please try again.",
  130: 'Please enter your date again.',
  201: 'Enter a valid date.',
  202: 'Date should be in the past.',
  203: 'Date should be in the future.',
  204: 'You must be at least 18 years old to apply.',
  205: 'You must be less than 120 years old to apply.',
  224: 'Date is required.',
  228: "That date isn't available. Please try again.",
}

const defaultCalendarSettings = { occurrence: 'past', areBankHolidaysDisabled: false, areWeekendsDisabled: false }
const defaultOptions = {
  reportingEntity: [],
  dealName: [],
  dealId: [],
  category: [],
  status: [],
  receivedDate: {
    dateInput: {
      initValue: '', inputName: 'Received Date'
    }, calendar: { ...defaultCalendarSettings, occurrence: 'past', areBankHolidaysDisabled: false, areWeekendsDisabled: false },
  },
};

function InboxFilters({ requirements, filters, setFilters }) {

  const [options, setOptions] = useState(defaultOptions);
  const [statusValue, setStatusValue] = useState([])
  // const statusOption = new Map();
  useEffect(() => {
    const addUniqueOption = (arr, label, value) => {
      if (label === undefined || value === undefined || label === null || value === null || label === '' || value === '') {
        return arr;
      }
      return arr.some(item => item.label === label && item.value === value)
        ? arr
        : [...arr, { label, value }];
    };

    const newOptions = (requirements || []).reduce((acc, current) => {
      const {
        category,
        metadata: { reportingEntity, dealName, dealId },
        status,
        requirementName,
      } = current;

      const capitalizedCategory = category.charAt(0).toUpperCase() + category.slice(1);
      return {
        ...acc,
        reportingEntity: addUniqueOption(acc.reportingEntity, reportingEntity, reportingEntity),
        dealName: addUniqueOption(acc.dealName, dealName, dealName),
        dealId: addUniqueOption(acc.dealId, dealId, dealId),
        category: ["investor reports", "true up review"].includes((category + "").toLowerCase()) ? addUniqueOption(acc.category, requirementName, requirementName + "*" + category) : addUniqueOption(acc.category, capitalizedCategory, category),
        status: [
          {
            label: "Read",
            value: "Read",
          },
          {
            label: "New",
            value: "New",
          }
          // ...acc.status,
          // {
          //   label: status,
          //   value: status,
          // },
        ],
      };
    }, defaultOptions);

    setOptions(newOptions);
    const finalarray = newOptions.status.filter((obj, index) => {
      return index === newOptions.status.findIndex(o => obj.label === o.label);
    })
    setStatusValue(finalarray)

  }, [requirements]);

  async function onSelectFilterChange(e, metadata) {

    const { name } = metadata;
    await setFilters((previous) => {
      if (e) {
        return { ...previous, [name]: e };
      }
      const { [name]: selectName, ...rest } = previous;
      return rest;
    });
  }

  function onClear() {
    setFilters(getDefaultFilters());
    window.location.href = '/Inbox';
  }

  return (
    <section className="filters-container">
      <section className="filters-all">
        {/* reportingEntity */}
        <section className="filter-item p-t-md">
          <Select
            label="Legal Entity"
            name="metadata.reportingEntity"
            isClearable
            options={options.reportingEntity}
            value={filters['metadata.reportingEntity']}
            onChange={onSelectFilterChange}
          ></Select>
        </section>
        <section className="filter-item p-t-md">
          <Select
            label="Deal Name"
            name="metadata.dealName"
            isClearable
            options={options.dealName}
            value={filters['metadata.dealName']}
            onChange={onSelectFilterChange}
          ></Select>
        </section>
        <section className="filter-item p-t-md">
          <Select
            label="Deal ID"
            name="metadata.dealId"
            isClearable
            options={options.dealId}
            value={filters['metadata.dealId']}
            onChange={onSelectFilterChange}
          ></Select>
        </section>
        <section className="filter-item p-t-md">
          <Select
            label="Document Type"
            name="category"
            isClearable
            options={[...new Map(options.category.map(item => [item.value, item])).values()]}
            value={filters['category']}
            onChange={onSelectFilterChange}
          ></Select>
        </section>
        <section className="filter-item p-t-md">
          <Select
            label="Status"
            name="status"
            value={filters.status}
            isClearable
            options={statusValue}
            onChange={onSelectFilterChange}
          ></Select>
        </section>
        <section className="filter-item p-t-md">
          <USBDatePicker
            id="asOfDate"
            inputName="asOfDate"
            addClasses="asOfDate"
            dynamicInputValue={defaultOptions.receivedDate.dateInput.initValue}
            statusUpdateCallback={(e) => {
              const name = { name: 'lastUpdateDate' }
              const DatepickerValue = { label: e.inputValue, value: e.inputValue }
              e.inputValue?.length === 10 ? onSelectFilterChange(DatepickerValue, name) : onSelectFilterChange('', name)
            }}
            settings={{
              dateInput: {
                initValue: filters?.receivedDate?.length == 10 ? filters?.receivedDate : undefined,
                isDateOfBirth: true,
                minimumAge: 0,
                maximumAge: 10,
                maxlength: 10,
                showRenderCount: false,
                inputName: 'date-picker_single-date--default',
                isDisabled: false,
                isOptional: false,
                isReadOnly: false,
                dataTestId: null,
              },
              calendar: {
                id: 'datepicker',
                ...defaultCalendarSettings,
                labelText: 'Received Date',
                areBankHolidaysDisabled: false,
                areWeekendsDisabled: false,
                occurrence: 'past',
                numberOfYearsToShow: '10',

              },
            }}
            content={{
              dateInput: {
                calendarButtonAriaLabel: 'Choose date',
                helperText: 'mm/dd/yyyy',
                helperTextOptional: 'Optional',
                labelText: 'Received Date',
                errorMessages: {
                  ...defaultDatePickerErrorMessages,
                  default: 'Please enter a valid date.',
                  118: 'Please enter a valid date.',
                  201: 'Please enter a valid date.',
                  202: 'Date should be in the past.',
                  203: 'Date should be in the future.',
                  221: 'Enter no more than 10 characters.',
                  213: 'Enter numbers only.',
                  224: '(Optional field)',
                  228: "That date isn't available. Please try again.",
                },
              },
              inputName: 'asOfDate',
            }}

          />
        </section>
        <section className="filter-item p-t-md">
          <USBButton
            name="clearfilter"
            variant="primary"
            handleClick={onClear}
            addClasses="clear-button"
          >
            Clear filters
          </USBButton>
        </section>
      </section>
    </section>
  );
}

export default InboxFilters;
